<template>
  <div class="flex justify-center">
    <TinyButton :src="ICON_MINUS" v-on:click="emit('decrease')" />
    <div
      class="font-outline-1 font-fredoka relative z-10 w-80 px-4 text-center text-2xl text-gray-100 drop-shadow"
    >
      {{ props.label }}
    </div>
    <TinyButton :src="ICON_PLUS" v-on:click="emit('increase')" />
  </div>
</template>
<script lang="ts" setup>
import { ICON_MINUS, ICON_PLUS } from '../services/Directus.ts';
import TinyButton from './TinyButton.vue';

const props = defineProps(['label']);
const emit = defineEmits(['decrease', 'increase']);
</script>
